import "../scss/index.scss";

jQuery(function ($) {
    
    
    
    $('body').on('click','.user-extra-permalink', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();
        
        var userExtraPermalink = $('#user-extra-wrapper').attr('data-permalink');
        var userExtraPermalinkOption = $(this).attr('data-permalink-option');
        
        if (typeof userExtraPermalinkOption !== 'undefined' && userExtraPermalinkOption.length) {
            userExtraPermalink += '?'+userExtraPermalinkOption;
        }
        
        window.location.href = userExtraPermalink;
    });
    

    $('body').on('submit','#user-extra-password-form', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();

        // L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>
        const ajaxurl = $(this).attr('action');
        const action = $(this).find(':submit').attr('data-action');
        const token = $(this).find('#user_extra_password_tokenPassword').val();

        // Les données de notre formulaire
        const data = $( this ).serialize() + '&action=' + action + '&seila_user_extra_token_password=' + token;

        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {

            if (body.data.type === 'html') {
                //var formInner = $(body.data.data).find('#user-extra-login-form').html();
                $('#user-extra-password').html(body.data.data);
            }
        });
    });
    
    $('body').on('submit','#user-extra-token-password-form', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();

        // L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>
        const ajaxurl = $(this).attr('action');
        const action = $(this).find(':submit').attr('data-action');

        // Les données de notre formulaire
        const data = $( this ).serialize() + '&action=' + action;

        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {

            if (body.data.type === 'html') {
                //var formInner = $(body.data.data).find('#user-extra-login-form').html();
                $('#user-extra-token-password').html(body.data.data);
            }
        });
    });
    
    $('body').on('submit','#user-extra-login-form', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();

        // L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>
        const ajaxurl = $(this).attr('action');
        const action = $(this).find(':submit').attr('data-action');

        // Les données de notre formulaire
        const data = $( this ).serialize() + '&action=' + action;

        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {

            if (body.data.type === 'html') {
                //var formInner = $(body.data.data).find('#user-extra-login-form').html();
                $('#user-extra-login').html(body.data.data);
            }
            
            if (body.data.type === 'redirect') {
                var url = $('#user-extra-wrapper').attr('data-permalink');
                window.location.href = url;
            }
        });
    });
    
    $('body').on('submit','#user-extra-token-activation-form', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();

        // L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>
        const ajaxurl = $(this).attr('action');
        const action = $(this).find(':submit').attr('data-action');

        // Les données de notre formulaire
        const data = $( this ).serialize() + '&action=' + action;

        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {

            //success => activation form
            if (body.success == true) {
                if (body.data.type === 'html') {
                    $('#user-extra-wrapper').html(body.data.data);
                }
            } else {
            
                if (body.data.type === 'html') {
                    $('#user-extra-token-activation').html(body.data.data);
                }
            }
        });
    });
    
    $('body').on('submit','#user-extra-activation-form', function (e) {

        // Empêcher l'envoi classique du formulaire
        e.preventDefault();

        // L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>
        const ajaxurl = $(this).attr('action');
        const action = $(this).find(':submit').attr('data-action');

        // Les données de notre formulaire
        const data = $( this ).serialize() + '&action=' + action;

        // Requête Ajax en JS natif via Fetch
        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(body => {
            if (body.data.type === 'html') {
                $('#user-extra-activation').html(body.data.data);
            }
            
            if (body.data.type === 'redirect') {
                var url = $('#user-extra-wrapper').attr('data-permalink');
                window.location.href = url;
            }
        });
    });
});